module.exports = __webpack_public_path__ + "img/down-icon.ef1d60b3.svg";